export const TAB_DROPSHIP = 'dropship';
export const TAB_REORDER = 'reorder';

export const CYMBIO_AUTOMATION_COOKIE = 'cymbio-automation';

export const POSITIVE = 'positive';
export const NEGATIVE = 'negative';
